import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";

import swal from "sweetalert2";

@Injectable()
export class LeadsGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate() {
    let userProfile = JSON.parse(window.localStorage.getItem("userProfile"));
    if (
      userProfile.role == "A.R Accountant" ||
      userProfile.role == "G.L Accountant" ||
      userProfile.role == "Treasury Accountant" ||
      userProfile.role == "Contractor"
    ) {
      swal("Insufficient Permissions, redirected to home page", "", "error");
      this.router.navigate(["pages"]);
      return false;
    } else return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/guards/leads.guard.ts